module.exports = __webpack_public_path__ + "static/media/help.77fc2629.svg";